import React, { Fragment, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import ContactSection from '../../components/ContactSection';
import { useSeo } from '../../hooks/useSeo';

const staticMeta = {
  title: 'Contact RashTech Info',
  description: 'Contact RashTech Info for project inquiries, support, or partnerships. We respond quickly.',
  url: 'https://rashtechinfo.com/contact',
  image: 'https://rashtechinfo.com/og-image.png',
  siteName: 'RashTech Info',
  keywords: 'contact, support, inquiry, partnership, RashTech Info',
  themeColor: '#0A0D1C',
};

const ContactPage = () => {
  const { seo } = useSeo('/getSeo');

  const computed = useMemo(() => {
    const dynamic = {
      title: seo?.title,
      description: seo?.metaDescription,
      keywords: seo?.metaKeywords,
      canonicalUrl: seo?.canonicalUrl,
    };
    return {
      title: dynamic.title || staticMeta.title,
      description: dynamic.description || staticMeta.description,
      keywords: dynamic.keywords || staticMeta.keywords,
      url: dynamic.canonicalUrl || staticMeta.url,
      image: staticMeta.image,
      siteName: staticMeta.siteName,
      themeColor: staticMeta.themeColor,
    };
  }, [seo]);

  return (
    <Fragment>
      <Helmet>
        <title>{computed.title}</title>
        <meta name="description" content={computed.description} />
        {computed.keywords && <meta name="keywords" content={computed.keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content={computed.themeColor} />
        {computed.url && <link rel="canonical" href={computed.url} />}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={computed.siteName} />
        <meta property="og:title" content={computed.title} />
        <meta property="og:description" content={computed.description} />
        {computed.url && <meta property="og:url" content={computed.url} />}
        {computed.image && <meta property="og:image" content={computed.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={computed.title} />
        <meta name="twitter:description" content={computed.description} />
        {computed.image && <meta name="twitter:image" content={computed.image} />}
      </Helmet>

      <Header />
      <main className="page_content about-page">
        <PageTitle pageTitle={'Contact Us'} pagesub={'Us'} pageTop={'Contact'} />
        <ContactSection />
        <CtaSection />
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  )
};

export default ContactPage;
